import { gql } from '@apollo/client';

/**
 * GraphQL mutation to create a session
 */
export const CREATE_SESSION = gql`
  mutation CreateSession($tokens: TokenInput!, $providerId: String!) {
    createSession(tokens: $tokens, providerId: $providerId) {
      success
      message
    }
  }
`;
